import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { EmailVerifyComponent } from './components/email-verify/email-verify.component';
import { CompareValidatorDirective } from './directive/compare-validator.directive';
import { MessageModule } from './message/message.module';
import { SupportPageComponent } from './components/support-page/support-page.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { EnrollComponent } from './components/enroll/enroll.component';
import { SimpleItComponent } from './components/simple-it/simple-it.component';
import { BlockedComponent } from './components/blocked/blocked.component';
import { RedeemPointsComponent } from './components/redeem-points/redeem-points.component';
import { SellerRewardsDialogComponent } from './components/seller-rewards-dialog/seller-rewards-dialog.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import {OpenHouseQuizComponent } from './components/open-house-quiz/open-house-quiz';
import { TranslateModule } from '@ngx-translate/core';
import { QuizComponent } from './components/quiz/quiz.component';
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { NgCircleProgressModule } from 'ng-circle-progress';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatCardModule} from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatButtonModule, MatProgressSpinnerModule, MatTableModule, MatTabsModule } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { ProgressInfoPopupComponent } from './components/progress-info-popup/progress-info-popup/progress-info-popup.component';
import { ActivityChallengeDocumentsComponent } from './components/activity-challenge-documents/activity-challenge-documents/activity-challenge-documents.component';
import { UserAccessValidationComponent } from './components/user-access-validation/user-access-validation/user-access-validation.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ApproverComponent } from '../approver/approver.component';
import { ApproverconformationComponent } from '../approverconformation/approverconformation.component';

import { NgxPaginationModule } from 'ngx-pagination';
import { DocumentProofsComponent } from './components/document-proofs/document-proofs/document-proofs.component';
import { DiscussionBoardComponent } from './components/discussion-board/discussion-board/discussion-board.component';
import { DndDirective } from '../dnd.directive';
import { CallbackComponent } from '../auth/callback.component';

@NgModule({
  imports: [
    CommonModule,
    MessageModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    RouterModule,
    MatSelectModule,
    MatDialogModule,
    TranslateModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    MatGridListModule,
    NgCircleProgressModule.forRoot(),
    MatCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatIconModule,
    //MatTableModule,
    //MatListModule,
    MatButtonModule,
    MatTabsModule,
    // MatMenuModule,
    // MatIconModule,
    // MatDatepickerModule
    SlickCarouselModule,
    NgxPaginationModule
  
  ],
  declarations: [
    EmailVerifyComponent,
    CompareValidatorDirective,
    SupportPageComponent,
    OpenHouseQuizComponent,
    TermsAndConditionsComponent,
    EnrollComponent,
    SimpleItComponent,
    BlockedComponent,
    RedeemPointsComponent,
    SellerRewardsDialogComponent,
    MaintenanceComponent,
    QuizComponent,
    ProgressInfoPopupComponent,
    ActivityChallengeDocumentsComponent,
    UserAccessValidationComponent,
    ApproverComponent,
    CallbackComponent,
    ApproverconformationComponent,
    DocumentProofsComponent,
    DiscussionBoardComponent,
    DndDirective
  ],
  entryComponents: [
    SellerRewardsDialogComponent,
    ApproverconformationComponent,
    DiscussionBoardComponent
  ],
  exports: [
    EmailVerifyComponent,
    CompareValidatorDirective,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatIconModule,
    //MatTableModule,
   // MatListModule,
    MatButtonModule,
    MatTabsModule,
    // MatMenuModule,
    // MatIconModule,
    // MatDatepickerModule
    DndDirective
  ]
})
export class SharedModule { }
